<template>
  <v-row class="pa-0 align-center">
    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} mb-2`" 
      v-for="(country, c) in counter" :key="'country-' + c">
        <v-row class="pa-2 align-center">
          <v-col cols="12" style="text-transform: uppercase;font-size:24px;" :class="`${arabic?'arFont':'enFont'} pa-1 text-center`" v-if="country[0].country_name">
            {{i18n[country[0].country_name.slug]}}
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 text-center`" v-for="(item, i) in country" :key="'item-' + i">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="primary white--text elevation-2 py-2">
                  <div style="text-transform: uppercase;" v-if="item.program_name">{{i18n[item.program_name.slug]}}</div>
                  <div style="text-transform: uppercase;" v-if="item.status_name">{{i18n[item.status_name.slug]}}</div>
                  <div style="text-transform: uppercase;">{{item.total_count}}</div>
                </div>
              </template>
              <div class="py-2">
                <div style="text-transform: uppercase;" v-if="item.program_name">{{i18n[item.program_name.slug]}}</div>
                <div style="text-transform: uppercase;" v-if="item.status_name">{{i18n[item.status_name.slug]}}</div>
                <div style="text-transform: uppercase;">{{item.total_count}}</div>
              </div>
            </v-tooltip>
          </v-col>

          <v-col cols="12" v-if="manage">
            <v-card :loading="loading">
              <v-row class="px-4">
                <v-col cols="12" v-if="manage">
                  <v-row class="align-center">
                    <v-col cols="12" v-for="(user, u) in country[0].users" :key="'user-'+u">
                      <v-row class="align-center">
                        <v-col cols="6" md="4">
                          {{user.name}} 
                          <v-chip label small v-if="user.assign">
                            {{user.assigned_today}} 
                            <span style="font-size:8px;">({{user.weighted_assign}})</span>
                          </v-chip>
                        </v-col>
                        <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                          <v-switch 
                            hide-details 
                            :class="`${arabic?'arFont':'enFont'}`" 
                            :name="i18n.assign"
                            @change="updateUser(user)"
                            :label="i18n.assign" v-model="user.assign">
                          </v-switch>
                        </v-col>
                        <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                          <v-autocomplete
                            :items="programs"
                            v-model="user.programs"
                            :label="i18n.userPrograms"
                            outlined
                            hide-details
                            dense
                            autocomplete="disabled"
                            chips
                            @change="updateUser(user)"
                            multiple
                            item-value="id"
                            :class="`${arabic?'arFont':'enFont'}`"

                          >
                            <template v-slot:selection="{ attr, on, item, selected }">
                              <span
                                v-bind="attr"
                                :input-value="selected"
                                v-on="on"
                                :class="`${arabic?'arFont':'enFont'}`"
                              >
                                <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <span
                                :class="`${arabic?'arFont':'enFont'}`"
                                v-if="item.slug"
                              >
                                {{i18n[item.slug]}}
                              </span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                          <v-text-field
                            :label="i18n.assignRatio"
                            hide-details 
                            outlined
                            autocomplete="disabled"
                            dense
                            :disabled="!user.assign"
                            @keyup="updateUser(user)"
                            @keypress="isNumber($event)"
                            :class="`${arabic?'arFont':'enFont'}`"
                            v-model="user.assign_ratio"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="manage">
                  <v-row class="align-center">
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-autocomplete
                        :items="programs"
                        v-model="reassign.program"
                        :label="i18n.program"
                        autocomplete="disabled"
                        outlined
                        hide-details
                        clearable
                        dense
                        item-value="id"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <template v-slot:selection="{ attr, on, item, selected }">
                          <span
                            v-bind="attr"
                            :input-value="selected"
                            v-on="on"
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            <v-chip x-small v-if="item.slug">{{i18n[item.slug]}}</v-chip>
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <span
                            :class="`${arabic?'arFont':'enFont'}`"
                            v-if="item.slug"
                          >
                            {{i18n[item.slug]}}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-menu
                        v-model="datesf[c]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="reassign.from"
                            label="From Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            hide-details
                            outlined
                            dense
                            clearable
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="reassign.from"
                          :allowed-dates="getAllowedDates"
                          @input="datesf[c] = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-menu
                        v-model="datest[c]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="reassign.to"
                            label="To Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details
                            dense
                            clearable
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="reassign.to"
                          :allowed-dates="getAllowedDates"
                          @input="datest[c] = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-btn block text color="success" :loading="loading"  @click="reassignLeads(country[0].country)"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >{{i18n.reassignLeads}}</v-btn>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-autocomplete
                        :items="country[0].users"
                        v-model="reassign.fromUser"
                        :label="i18n.employee"
                        multiple
                        autocomplete="disabled"
                        outlined
                        hide-details
                        clearable
                        dense
                        item-value="id"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <template v-slot:selection="{ attr, on, item, selected }">
                          <span
                            v-bind="attr"
                            :input-value="selected"
                            v-on="on"
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            <v-chip x-small>{{item.name}}</v-chip>
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <span
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            {{item.name}}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-autocomplete
                        :items="country[0].users"
                        v-model="reassign.toUser"
                        :label="i18n.employee"
                        multiple
                        autocomplete="disabled"
                        outlined
                        hide-details
                        clearable
                        dense
                        item-value="id"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <template v-slot:selection="{ attr, on, item, selected }">
                          <span
                            v-bind="attr"
                            :input-value="selected"
                            v-on="on"
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            <v-chip x-small>{{item.name}}</v-chip>
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <span
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            {{item.name}}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-text-field
                        :label="`Limit`"
                        hide-details 
                        outlined
                        autocomplete="disabled"
                        dense
                        :class="`${arabic?'arFont':'enFont'}`"
                        v-model="reassign.limit"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-autocomplete
                        :items="statuses.filter(x=>x.id != 2)"
                        v-model="reassign.status"
                        :label="i18n.statuses"
                        autocomplete="disabled"
                        outlined
                        hide-details
                        clearable
                        dense
                        item-value="id"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <template v-slot:selection="{ attr, on, item, selected }">
                          <span
                            v-bind="attr"
                            :input-value="selected"
                            v-on="on"
                            :class="`${arabic?'arFont':'enFont'}`"
                          >
                            <v-chip x-small v-if="item.slug">{{i18n[item.slug]}}</v-chip>
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <span
                            :class="`${arabic?'arFont':'enFont'}`"
                            v-if="item.slug"
                          >
                            {{i18n[item.slug]}}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`">
                      <v-btn block text color="success" :loading="loading"  @click="transferLeads(country[0].country)"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >{{i18n.transferLeads}}</v-btn>
                    </v-col>
                    <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-1`" v-if="user.hq">
                      <v-btn block text color="success" :loading="loading"  @click="transferAllLeads(country[0].country)"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >Transfer All Leads</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  props:['counter', 'totals', 'loading', 'manage', 'programs', 'statuses', 'time', 'user'],
  data() {
    return {
      reassign:{},
      datesf:{},
      datest:{},
    }
  },
  methods:{
    getAllowedDates(val) {
      let today = new Date().toISOString()
      let seven = new Date().getTime() - 5*31*24*60*60*1000
      return new Date(val).getTime() > seven
    },
    async reassignLeads(c) {
      this.reassign.country = c
      this.$emit('reassign', this.reassign)
    },
    async transferLeads(c) {
      this.reassign.country = c
      this.$emit('transfer', this.reassign)
    },
    async transferAllLeads(c) {
      this.reassign.country = c
      this.$emit('transferAll', this.reassign)
    },
    async updateUser(user) {
      this.$emit('updateUser', user)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>

</style>